import { render, staticRenderFns } from "./StudentTicketPage.vue?vue&type=template&id=6c0f76d9&scoped=true&"
import script from "./StudentTicketPage.vue?vue&type=script&lang=js&"
export * from "./StudentTicketPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0f76d9",
  null
  
)

export default component.exports